export default __webpack_public_path__ + "static/media/135.9b8e9046.jpg";